import { render, staticRenderFns } from "./AdditionalInformationCard.vue?vue&type=template&id=1ccb94ec&scoped=true&"
import script from "./AdditionalInformationCard.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationCard.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInformationCard.vue?vue&type=style&index=0&id=1ccb94ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb94ec",
  null
  
)

export default component.exports